<app-navbar *ngIf="!hideNavbar"></app-navbar>

<div class="main-container">
  <div class="internal-loading-page component-loading animated fadeIn" *ngIf="componentLoadding">
    <span class="loader"></span>
  </div>
  <router-outlet *ngIf="!componentLoadding" class="animated fadeIn"></router-outlet>
</div>

<footer class="main-footer bg-transparent container-fluid fixed-bottom text-secondary d-flex align-items-center"
  [ngClass]="{'bg-transparent': hideNavbar, 'bg-white text-dark': !hideNavbar}">
  <div class="row w-100 m-0">
    <div class="col text-center footer-center-content">
      <span [ngClass]="{'text-light': hideNavbar, 'text-dark': !hideNavbar}">
        {{ 'FOOTER.SLOGAN-SHORT' | translate: { theme: theme, currentYear: currentYear } }}
        <span [ngClass]="{'text-light': hideNavbar, 'text-dark': !hideNavbar}" *ngIf="currentVersion"> - v{{
          currentVersion }}</span>
        <span>
          - <a class="text-link" [ngClass]="{'text-light': hideNavbar, 'text-dark': !hideNavbar}"
            [href]="thirdPartiesLicences" target="_blank">
            {{ 'GLOBAL.THIRD-PARTIES' | translate }}
          </a>
        </span>
      </span>
    </div>
  </div>
</footer>

<div class="globalLoading position-fixed w-100 h-100 fix-parent-height-center-center"
  style="transition: all .3s; display: none;">
  <span class="loader"></span>
</div>